import { Component, HostListener, inject, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { ConfirmationDialogData } from './confirmation-dialog-data';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton, MatButton } from '@angular/material/button';
import { AriaLabelDirective, GtmClickDirective } from 'src/app/shared/directives';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { ADPComponentsModule, ADPResourceService } from 'digital-core';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatInput } from '@angular/material/input';
import { InputNumberDirective } from 'src/app/shared/directives';
import { GTMEvents, GTMModalCategories } from '../../../model/google-tag-manager/api-status';
import { GoogleAnalyticsService } from '../../../core/services';
// import { MatDialogContent } from '@angular/material/dialog';

@Component({
  selector: 'pgh-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  imports: [
    MatIconButton,
    AriaLabelDirective,
    MatDialogClose,
    MatIcon,
    MatDialogTitle,
    NgClass,
    ADPComponentsModule,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatInput,
    InputNumberDirective,
    MatButton,
    GtmClickDirective,
  ],
})
export class ConfirmationDialogComponent implements OnInit {
  public confirmPhoneNumber: string;
  public form: FormGroup;

  private resourceService = inject(ADPResourceService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      phoneNumber: [''],
    });
  }

  public get isPhoneNumberMatching(): boolean {
    return this.data.phoneNumber.replace(/[^0-9]/g, '').substring(6) === this.form.get('phoneNumber').value;
  }

  public get hasError(): boolean {
    if (!this.isPhoneNumberMatching && this.form.get('phoneNumber').value.length == 4) {
      return true;
    }
    return false;
  }

  public ngOnInit(): void {
    this.googleAnalyticsService.emitClickEvent(GTMEvents.ModalView, this.resourceService.getViewLabel(this.data.title) ?? '', '', GTMModalCategories.Informative);
  }
}
